import { authEndpoints as auth } from '@/api/endpoints/auth';
import { userEndpoints as user } from '@/api/endpoints/user';
import { taxPayerEndpoints as taxpayer } from '@/api/endpoints/taxpayer';

export const ENDPOINTS = { auth, user, taxpayer };
